// ------------------------------------
// Imports
// ------------------------------------
import { UPDATE_LOCATION } from 'redux/actions/windowLocation';

// ------------------------------------
// Reducer Handlers
// ------------------------------------
const REDUCER_HANDLER = {
  [UPDATE_LOCATION]: (state, action) => ({ location: action.payload })
};

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
  location: {}
};

export default function windowLocation(state = initialState, action) {
  const handler = REDUCER_HANDLER[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/windowLocation.js